import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authStorage } from '../utils/authStorage';

const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();

  if (!authStorage.isLoggedIn()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
};

export default RequireAuth;
